import { RemainingPaymentInfo } from "./payment";
import { OrderTicket } from "./ticket-order";

export { OrderTicket };

export interface OrderCoupon {
  code: string;
  discount_amount: number;
}

export interface Order {
  id: number;
  total_amount: string;
  payment_method: string;
  pdv?: boolean;
  payment_status: string;
  payment_status_display: string;
  paid_at: string;
  tickets: OrderTicket[];
  refund_request_status?: RefundRequestStatus | null;
  refund_available?: boolean;
  refund_reason?: RefundReason | null;
  /** Multimeios parcial: valor que ainda falta pagar. */
  remaining_payment?: RemainingPaymentInfo | null;
  // Cupom aplicado no pedido (histórico fiel, não recalculado). `discount_amount`
  // sempre presente (0 quando não houve cupom); `coupon` é null sem cupom.
  discount_amount?: number;
  coupon?: OrderCoupon | null;
}

export type RefundReason =
  | "arrependimento"
  | "event_changed"
  | "event_cancelled";

export enum RefundRequestStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}

export enum OrderPaymentStatusEnum {
  WaitingPayment = "waiting_payment",
  Processing = "processing",
  Paid = "paid",
  Refused = "refused",
  Pending = "pending",
  Canceled = "canceled",
  Refunded = "refunded",
  RefundRequested = "refund_requested",
  RefundRejected = "refund_rejected",
  Expired = "expired",
  Courtesy = "courtesy",
  Failed = "failed",
  Transferred = "transferred",
}

export const OrderRequestTimeframeEnum = {
  FUTURES: "future",
  FINISHED: "past",
  EXPIRED: "expired",
} as const;

export type OrderRequestTimeframe =
  (typeof OrderRequestTimeframeEnum)[keyof typeof OrderRequestTimeframeEnum];
